function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#smoke_svg__clip0_1_100)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.185 3.242l3.4 3.4 9.2 9.2a.646.646 0 00.844 0l2.24-2.24a.622.622 0 00.184-.422.525.525 0 00-.185-.422l-2.346-2.346L6.67 3.558 3.269.185a.589.589 0 00-.844 0l-2.24 2.24A.622.622 0 000 2.847a.78.78 0 00.185.395zm12.098 7.618l-1.397 1.397L4.85 6.221l1.397-1.397 6.036 6.036zm.95 3.743l-1.53-1.529 1.398-1.397 1.528 1.529-1.397 1.397zM11.535.58v5.64c0 .317.39.58.857.58.468 0 .857-.263.857-.58V.58c0-.316-.39-.58-.857-.58-.468 0-.857.264-.857.58zm5.071 0c0-.316-.39-.58-.857-.58-.467 0-.857.264-.857.58v8.119c0 .316.39.58.857.58.468 0 .857-.264.857-.58V.579z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "smoke_svg__clip0_1_100"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h17v16H0z"
})));

function SvgSmoke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSmoke;